import { useDispatch, useSelector } from "react-redux";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GDeleteModal from "components/ui/modal/DeleteModal";
import { useNavigate } from "react-router-dom";
import routes from "navigations/routes";
import { deleteTimedEvent } from "../../services/timedEventsService";

const DeleteModal = ({ id, onClose }) => {
  console.log("id", id);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const dispatch = useDispatch();
  const timedEvents = useSelector((state) => state.timedEvents);

  return (
    <GDeleteModal
      onClose={onClose}
      onSubmit={() => {
        dispatch(deleteTimedEvent(id))
          .unwrap()
          .then((_) => {
            toast({ description: t("pages.timedEvents.timed_event_deleted") });
            onClose();
            navigate(`/${routes.management_timed_events}`);
          });
      }}
      isLoading={timedEvents.isLoading}
    />
  );
};

export default DeleteModal;
